module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2019-10-20 at 5.31 1.5b9953aa.svg";